import React, { useState } from 'react'
import { Link as GatsbyLink, useStaticQuery, graphql } from 'gatsby'
import { FontAwesomeIcon } from '../../libs/fonts';

const DefaultHeader = () => (
  // TODO
  <></>
);

const Link = ({ to, activeClassName, children }) => {
  if (to.startsWith('http')) {
    return (
      <a href={to} target='_blank' rel='noreferrer'>{children}</a>
    );
  }
  return (
    <GatsbyLink activeClassName={activeClassName} to={to}>{children}</GatsbyLink>
  );
}

const Header = () => {
  const [navHidden, setNavHidden] = useState(true);

  const headerQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        oneHeader(
          options: {
            limit: 1
            cachebust: true
          }
        ) {
          content
        }
      }
    }
  `);

  const data = headerQuery?.allBuilderModels?.oneHeader?.content?.data;

  if (!data) {
    return DefaultHeader;
  }

  const { logo, mainLinks, moreLinks, actionButtons, routeNames } = data;

  const routes = routeNames.map(({ name }) => {
    const slug = name.replace(/[\W]/g, '-').toLowerCase()
    return { name, slug };
  });

  const filteredMainLinks = mainLinks.filter(({ hide }) => !hide);
  const filteredMoreLinks = moreLinks.filter(({ hide }) => !hide);
  const filteredActionButtons = actionButtons.filter(({ hide }) => !hide);

  return (
    <header id='rs-header' className='rs-header header-style5 header-transparent'>

      <div className='menu-area menu-sticky'>
        <div className='container'>
          <div className='row-table'>
            <div className='col-cell header-logo'>
              <div className='logo-area'>
                <Link to='/'>
                  <img
                    src={logo}
                    alt='CommCon 2024'
                    style={{ maxWidth: 200 }}
                    loading='eager'
                    placeholder='none'
                  />
                </Link>
              </div>
            </div>

            {/* Desktop version */}
            <div className='col-cell'>
              <div className='rs-menu-area' style={{ margin: '0 20px' }}>
                <div className='main-menu'>
                  <nav className='rs-menu hidden-md'>
                    <ul className='nav-menu'>
                      {!!filteredMainLinks?.length && filteredMainLinks.map(({ submenuLinks, text, url, enableRoutes }) => {
                        const filteredSubmenuLinks = submenuLinks?.filter(({ hide }) => !hide);
                        if (!!filteredSubmenuLinks?.length) {
                          return (
                            <li className='menu-item-has-children' key={`submenu/${text}`}>
                              <button>{text}</button>
                              <ul className='sub-menu'>
                                {filteredSubmenuLinks.map(({ text: subText, url: subUrl }) => (
                                  <li key={subUrl}>
                                    <Link activeClassName='current-menu-item' to={subUrl}>
                                      {subText}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          );
                        }
                        if (enableRoutes && routes.length) {
                          return (
                            <li className='menu-item-has-children' key={`route/${text}`}>
                              <button>{text}</button>
                              <ul className='sub-menu'>
                                {routes.map(({ name, slug }, i) => (
                                  <li key={`${url}/${slug}`}>
                                    <Link activeClassName='current-menu-item' to={`${url}/${slug}`}>
                                      {name.toUpperCase()}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          );
                        }
                        return (
                          <li key={url}>
                            <Link activeClassName='current-menu-item' to={url}>{text}</Link>
                          </li>
                        );
                      })}

                      {!!filteredMoreLinks.length && (
                        <li className='menu-item-has-children'>
                          <button>More</button>
                          <ul className='sub-menu'>
                            {filteredMoreLinks.map(({ url, text }) => (
                              <li key={`more/${url}`}>
                                <Link activeClassName='current-menu-item' to={url}>{text}</Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}

                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            {/* Action buttons */}
            <div className='col-cell'>
              <div className='expand-btn-inner'>
                <ul>
                  {!!filteredActionButtons.length && filteredActionButtons.map(({ url, text }) => (
                    <li key={`button/${url}`} className='btn-quote' style={{ marginRight: 12 }}>
                      <a href={url} className='quote-button'>{text}</a>
                    </li>
                  ))}
                  <li className='humburger'>
                    <div className='bar'>
                      <FontAwesomeIcon icon='fa-solid fa-bars' onClick={() => {
                        setNavHidden(false);
                      }} />
                    </div>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Mobile version */}
      <nav className={`right_menu_togle mobile-navbar-menu ${navHidden ? 'hide-right' : ''}`} id='mobile-navbar-menu'>
        <div className='close-btn'>
          <button
            className='nav-close'
            onClick={() => setNavHidden(true)}
          >
            <div className='line'>
              <span className='line1' />
              <span className='line2' />
            </div>
            <span style={{ display: 'none' }}>menu toggle button</span>
          </button>
        </div>

        <ul className='nav-menu'>
          {!!filteredMainLinks?.length && filteredMainLinks.map(({ submenuLinks, text, url, enableRoutes }, i) => {
            const filteredSubmenuLinks = submenuLinks?.filter(({ hide }) => !hide);
            if (!!filteredSubmenuLinks?.length) {
              return (
                <div key={`mobile/submenu/${text}`}>
                  {filteredSubmenuLinks.map(({ url, text }) => (
                    <li key={`mobile/submenu/${text}/${url}`}>
                      <Link activeClassName='current-menu-item' to={url}>
                        {text}
                      </Link>
                    </li>
                  ))}
                </div>
              );
            }
            if (enableRoutes && routes.length) {
              return (
                <div key={`mobile/route/${text}`}>
                  {routes.map(({ name, slug }) => (
                    <li key={`mobile/route/${text}/${url}/${slug}`}>
                      <Link activeClassName='current-menu-item' to={`${url}/${slug}`}>
                        {text} - {name.toUpperCase()}
                      </Link>
                    </li>
                  ))}
                </div>
              );
            }
            return (
              <li key={`mobile/${url}`}>
                <Link activeClassName='current-menu-item' to={url}>{text}</Link>
              </li>
            );
          })}
          {!!filteredMoreLinks?.length && filteredMoreLinks.map(({ text, url }) => (
            <li key={`mobile/more/${url}`}>
              <Link activeClassName='current-menu-item' to={url}>{text}</Link>
            </li>
          ))}
          {!!filteredActionButtons?.length && filteredActionButtons.map(({ text, url }) => (
            <li key={`mobile/button/${url}`}>
              <Link activeClassName='current-menu-item' to={url}>{text}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
